import React, { useState, useEffect } from 'react';
import {
    Grid,
    IconButton,
    makeStyles
} from "@material-ui/core";
import { connect } from 'react-redux';
import { numberFormat } from "../../../../utils/utils";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import classNames from 'classnames';
import EditIcon from '@material-ui/icons/Edit';
import EditDieselCardDialog from "./EditDieselCard";
import { getSingleDieselCard } from "../../../../store/actions/vehicleActionCreator";
import { useHistory, useLocation } from "react-router-dom";
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../../paginationVariables';
import * as logger from "../../../../logger";

const useStyles = makeStyles(() => ({

    titleV1: {
        fontSize: '12px',
        fontWeight: 600,
    },
    textAlignLeft: {
        textAlign: 'left'
    },
    textAlignRight: {
        textAlign: 'right'
    },
    mt4: {
        marginTop: '4px'
    },
    divAlign: {
        display: 'flex'
    },
    gridContainerV1: {
        backgroundColor: 'white',
        borderRadius: '4px',
        padding: 24,
        width: 'inherit'
    },
    ml4: {
        marginLeft: 4
    },
    blueColor: {
        color: '#2c5de5'
    },
    fs16: {
        fontSize: 16
    },
    imgV1: {
        width: 40,
        height: 40
    },
    ml28: {
        marginLeft: 28
    },
    ml16: {
        marginLeft: 16
    },
    titleV2: {
        color: 'rgba(11, 19, 35, 0.75)'
    },
    fs18: {
        fontSize: 18
    },
    balanceText: {
        color: '#2652d4',
        fontWeight: 600,
        marginLeft: '8px'
    },
    circleIcon: {
        color: '#dedede',
        fontSize: 8,
        marginLeft: 8,
        marginRight: 8,
        marginTop: -3
    },
    mobileNumberText: {
        color: 'rgba(11, 19, 35, 0.75)',
        width: '11em'
    },
    editButton: {
        borderRadius: '4px',
        border: 'solid 1px #1461d2',
        width: '32px',
        height: '32px'
    },
    editIcon: {
        color: '#1461d2',
        fontSize: 18
    },
    width50: {
        width: '50%'
    },
    width35: {
        width: '35%'
    },
    width15: {
        width: '15%'
    },
    width10: {
        width: '10%'
    },
    width90: {
        width: '90%'
    },
    width100: {
        width: '100%'
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center'
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center',
        overflowWrap: 'anywhere'
    },
    truckDetailsGrid: {
        borderBottom: '1px solid #e6e6e6',
        paddingBottom: '16px'
    },
    mt16: {
        marginTop: 16
    },
    truckNumbertext: {
        display: 'flex',
        fontSize: 16,
        fontWeight: 600,
        marginLeft: 24
    },
    marketLabel: {
        backgroundColor: '#e86825',
        color: 'white',
        fontSize: 10,
        borderRadius: 4,
        padding: '3.8px 4.5px 3.9px 5px',
        textTransform: 'none'
    },
    ownLabel: {
        backgroundColor: '#0033cc',
        color: 'white',
        fontSize: 10,
        borderRadius: 4,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 2,
        paddingBottom: 2,
        textTransform: 'none'
    },

}));

const DieselCardDetails = ({ vehicle, dispatchGetSingleDieselCardDetails }) => {

    let location = useLocation();

    const [singleDieselCardValue, setSingleDieselCardValue] = useState({});
    const [editDieselCardOpen, setEditDieselCardOpen] = useState(false);

    const classes = useStyles();

    useEffect(() => {

        if (vehicle && vehicle.singleDieselCardInfo) {
            setSingleDieselCardValue(vehicle.singleDieselCardInfo)
        }

    }, [vehicle]);

    const handleEditDieselCardClose = () => {
        setEditDieselCardOpen(false);

        const pathName = location && location.pathname ? location.pathname.split("/") : [];
        const brokerId = pathName && pathName[pathName.length - 1] ? pathName[pathName.length - 1] : "";

        const requestData = {
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
            vehicleId: singleDieselCardValue && singleDieselCardValue.vehicleId ? singleDieselCardValue.vehicleId : "",
            brokerId: brokerId
        }

        dispatchGetSingleDieselCardDetails(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Diesel Card Details Single Diesel Card Dweb", "Get Single Diesel Card Details Successfull");
                }
            },
            () => {
                logger.log("Diesel Card Details Single Diesel Card Dweb", "Get Single Diesel Card Details Failed");
            }
        )

    }

    const handleEditClick = () => {
        setEditDieselCardOpen(true);
    }

    return (
        <>
            <Grid container className={classes.gridContainerV1}>

                {/* ***************************** Truck Number abd diesel card balance ***************************** */}
                <Grid container alignItems='center' justify='space-between' className={classes.truckDetailsGrid}>
                    <Grid item>
                        <div className={classes.divAlignV1}>
                            <div>
                                <img src={singleDieselCardValue && singleDieselCardValue.s3UrlForImage && singleDieselCardValue.s3UrlForImage.small ? singleDieselCardValue.s3UrlForImage.small : ""} className={classes.imgV1} />
                            </div>
                            <div className={classes.truckNumbertext}>
                                {singleDieselCardValue && singleDieselCardValue.vehicleNumArrayValue && singleDieselCardValue.vehicleNumArrayValue.map((truckNumber, index) => (
                                    <div className={index != 0 ? classes.ml4 : ""}><span className={index == singleDieselCardValue.vehicleNumArrayValue.length - 1 ? classes.blueColor : ""}>{truckNumber}</span></div>
                                ))}
                            </div>
                            <div className={classNames(classes.ml16)}>
                                {singleDieselCardValue && singleDieselCardValue.ownershipType && singleDieselCardValue.ownershipType.toLowerCase() == "hired" ?
                                    <div className={classes.marketLabel}>Market</div>
                                    :
                                    <div className={classes.ownLabel}>Own</div>
                                }
                            </div>
                        </div>
                    </Grid>
                    <Grid item>
                        <div className={classes.divAlign}>
                            <div className={classNames(classes.titleV2, classes.fs16)}>Balance :</div>
                            <div className={classNames(classes.fs18, classes.balanceText)}>{numberFormat(singleDieselCardValue && singleDieselCardValue.balance ? singleDieselCardValue.balance : 0)}</div>
                        </div>
                    </Grid>
                </Grid>

                <Grid container className={classes.mt16} wrap="nowrap" alignItems='center'>

                    {/* ********************** Diesel Card Info ********************** */}
                    <Grid item className={classes.width90}>
                        <div className={classNames(classes.width100, classes.divAlign)}>
                            <div className={classNames(classes.titleV1, classes.textAlignLeft, classes.width50)}>Driver Details</div>
                            <div className={classNames(classes.titleV1, classes.textAlignLeft, classes.width35)}>Card Number</div>
                            <div className={classNames(classes.titleV1, classes.textAlignRight, classes.width15)}>PIN</div>
                        </div>
                        <div className={classNames(classes.width100, classes.divAlign)}>
                            <div className={classNames(classes.mt4, classes.divAlignV2, classes.width50)}>
                                <div>{singleDieselCardValue && singleDieselCardValue.driverName ? singleDieselCardValue.driverName : ""}</div>
                                {singleDieselCardValue && singleDieselCardValue.mobileNumber &&
                                    <>
                                        <div><FiberManualRecordIcon className={classes.circleIcon} /></div>
                                        <div className={classes.mobileNumberText}>{singleDieselCardValue.mobileNumber}</div>
                                    </>
                                }
                            </div>
                            <div className={classNames(classes.mt4, classes.width35)}>{singleDieselCardValue && singleDieselCardValue.cardNumber ? (singleDieselCardValue.cardNumber.match(/.{1,4}/g)).join("-") : "--"}</div>
                            <div className={classNames(classes.mt4, classes.textAlignRight, classes.width15)}>{singleDieselCardValue && singleDieselCardValue.pin ? singleDieselCardValue.pin : "--"}</div>
                        </div>
                    </Grid>

                    {/* ************************** Edit Button ************************** */}
                    <Grid item className={classNames(classes.width10, classes.textAlignRight)}>
                        <IconButton className={classes.editButton} onClick={() => handleEditClick()}>
                            <EditIcon className={classes.editIcon} />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>

            {/* *********************************** Edit Diesel card Dialog *********************************** */}
            {editDieselCardOpen && <EditDieselCardDialog open={editDieselCardOpen} onClose={handleEditDieselCardClose} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchGetSingleDieselCardDetails: (data, onSuccess, onError) => { dispatch(getSingleDieselCard(data, onSuccess, onError)) }

})

export default connect(mapStateToProps, mapDispatchToProps)(DieselCardDetails)
